import React, { useEffect } from "react";
import { Link } from "react-router";
import Icon from "../Icon";
import { FormattedMessage } from "react-intl";
import useQuickPayContext from "assets/scripts/components/containers/public/QuickPay/useQuickPayContext";
const NavigationItem = (props) => (<li className="navigation-item">
		<Link className="navigation-item-link" activeClassName="navigation-item-link-active" onlyActiveOnIndex to={props.to} aria-labelledby={props.labelId}>
			<span className="navigation-item-link-icon">
				<Icon icon={props.icon}/>
			</span>
			<span className="navigation-item-link-text" id={props.labelId}>
				{props.children}
			</span>
		</Link>
	</li>);
const AppHeaderCore = (props) => {
    let nav = null;
    let homePath = "/public";
    const quickPayContext = useQuickPayContext();
    if (props.display) {
        homePath = "/secured";
        nav = (<div className="header-wrapper-content-navigation">
				<h3 className="u-isVisuallyHidden">
					<FormattedMessage id="header.navHeading" defaultMessage="Main Site Navigation"/>
				</h3>
				<ul className="navigation">
					<NavigationItem to="/secured" labelId="nav-dashboard" icon="home">
						<FormattedMessage id="header.dashboard" defaultMessage="Dashboard"/>
					</NavigationItem>
					<NavigationItem to="/secured/editProfile" labelId="nav-profile" icon="profile">
						<FormattedMessage id="header.profile" defaultMessage="My Profile"/>
					</NavigationItem>
					{process.env.FEATURE_DOCUMENTS && (<NavigationItem to="/secured/documents" labelId="nav-documents" icon="document">
							<FormattedMessage id="header.documents" defaultMessage="Documents"/>
						</NavigationItem>)}
					{process.env.CLIENT !== "CapOne" && (<NavigationItem to="/secured/disclosures" labelId="nav-disclosures" icon="court">
							<FormattedMessage id="header.disclosures" defaultMessage="Disclosures"/>
						</NavigationItem>)}
					<NavigationItem to="/secured/contact" labelId="nav-contact" icon="phone">
						<FormattedMessage id="header.contact" defaultMessage="Contact"/>
					</NavigationItem>
					<NavigationItem to="/secured/emailOptOut" labelId="nav-emailOptOut" icon="emailOptOut">
						<FormattedMessage id="header.emailOptOut" defaultMessage="Email Preferences"/>
					</NavigationItem>
					<li className="navigation-item">
						<button className="navigation-item-link" onClick={props.logout} aria-labelledby="nav-logout">
							<span className="navigation-item-link-icon">
								<Icon icon="logout"/>
							</span>
							<span className="navigation-item-link-text" id="nav-logout">
								<FormattedMessage id="header.logout" defaultMessage="Logout"/>
							</span>
						</button>
					</li>
				</ul>
			</div>);
    }
    if (!!quickPayContext.token) {
        const token = encodeURIComponent(quickPayContext.token);
        nav = (<div className="header-wrapper-content-navigation">
				<h3 className="u-isVisuallyHidden">
					<FormattedMessage id="header.navHeading" defaultMessage="Main Site Navigation"/>
				</h3>
				<ul className="navigation">
					<NavigationItem to={`/public/QuickPay/${token}/Pay`} labelId="nav-quickpay" icon="quickpay">
						<FormattedMessage id="header.quickpay.pay" defaultMessage="Quick Pay"/>
					</NavigationItem>
					{!quickPayContext.quickPayOnly && (<NavigationItem to={`/public/QuickPay/${token}/Register`} labelId="nav-quickpay-register" icon="register">
							<FormattedMessage id="header.quickpay.register" defaultMessage="Register"/>
						</NavigationItem>)}
					<NavigationItem to={`/public/QuickPay/${token}/Disclosures`} labelId="nav-quickpay-disclosures" icon="court">
						<FormattedMessage id="header.quickpay.disclosures" defaultMessage="Disclosures"/>
					</NavigationItem>
					<NavigationItem to={`/public/QuickPay/${token}/Contact`} labelId="nav-quickpay-contact" icon="phone">
						<FormattedMessage id="header.quickpay.contact" defaultMessage="Contact"/>
					</NavigationItem>
				</ul>
			</div>);
    }
    useEffect(() => {
        const navElements = Array.from(document.getElementsByClassName("navigation-item-link"));
        navElements.forEach((navElement) => {
            if (navElement.classList.contains("navigation-item-link-active"))
                navElement.setAttribute("aria-current", "page");
            else
                navElement.removeAttribute("aria-current");
        });
    });
    return (<header role="banner">
			<div>
				{props.banner}
				<div className="header">
					<div className="header-wrapper">
						<nav className="header-wrapper-content" aria-label="main">
							<div className="header-wrapper-content-logo">
								<Link to={homePath} className="logo">
									<img className="imgFill" itemProp="logo" src={props.logo} alt={props.logoAlt}/>
								</Link>
							</div>
							{nav}
						</nav>
					</div>
				</div>
			</div>
		</header>);
};
export default AppHeaderCore;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/presentational/AppHeader/AppHeaderCore.tsx